import { render, staticRenderFns } from "./cardPaciente.vue?vue&type=template&id=b022e95a&scoped=true"
import script from "./cardPaciente.vue?vue&type=script&lang=js"
export * from "./cardPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b022e95a",
  null
  
)

export default component.exports